import { Component, input, signal } from '@angular/core';
import { DropdownControl } from '../../../controls/setup-wizard/dropdown-control/dropdown-control';
import { LanguageCode } from '@mira-avant/mtlibs';
import { FormGroup } from '@angular/forms';

@Component({
	selector: 'app-language-dropdown-field',
	imports: [DropdownControl],
	standalone: true,
	templateUrl: './language-dropdown-field.html',
	styleUrl: './language-dropdown-field.scss',
})
export class LanguageDropdownField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	formGroup = input.required<FormGroup>();
	options = signal<{ value: string; label: string }[]>(
		Object.values(LanguageCode).map(value => ({ value, label: value }))
	);
}
